import Controller, { OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { FetchAPI } from '@philips-internal/oswald-ui-components';
import { AuthenticationService, HttpService, JWTToken } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import TokenConstants from '../../constants/TokenConstants';
import ResultTermServiceAPI from '@philips-emr/referring-physician-components/lib/components/result-term-service/result-term-service-api';

interface CheckTermUse {
  termSeqNr: number;
}

interface TermsUse {
  termSeqNr: number;
}

@Controller({ fragment: 'assign-terms-of-use-modal', component: 'assign-terms-modal' })
export default class AssignTermsOfUseModalController extends BaseController {

  @Inject('terms-fetch')
  fetchTermoUso: FetchAPI;

  @Inject('newaccount.link.terms')
  checkTerm: ResultTermServiceAPI;

  @OnMount({ target: ['assign-terms-modal'] })
  onMount(): void {
    this.checkTermOfUse();
    const { termSeqNr } = this.historyService.getCurrentRouteParams() as Record<string,string>;
    this.context.set({ termSeqNr });
    const nrSeqValid = termSeqNr !== 'undefined';
    this.checkTerm.setEnabled(nrSeqValid);
    if (nrSeqValid) {
      this.fetchTermoUso.forceFetch();
    }
  }

  checkTermOfUse(): void {
    HttpService.get(APPLICATION_ENDPOINTS.CHECK_TERMS_OF_USE).then((result) => {
      const checkTerm = result.body as CheckTermUse;
      if (checkTerm.termSeqNr) {
        AuthenticationService.logout();
      }
    });
  }

  @OnClose({ target: ['assign-terms-modal'] })
  onclose(): void {
    AuthenticationService.logout();
  }

  @OnMount({ target: 'newaccount.link.terms' })
  onTermo(): void {
    this.checkTerm.onSubmitTermUse.listen(() => this.onSubmitTermUse());
  }

  onSubmitTermUse(): void {
    const { termSeqNr } = this.historyService.getCurrentRouteParams();
    if (termSeqNr !== 'undefined') {
      HttpService.put(APPLICATION_ENDPOINTS.UPDATE_TERMS_OF_USE, { termSeqNr }).then(() => {
        HttpService.get(APPLICATION_ENDPOINTS.CHECK_PRIVACY).then(respCheckAviso => {
          const checkDataAviso = respCheckAviso.body as CheckTermUse;
          if (!checkDataAviso.termSeqNr) {
            HttpService.get(APPLICATION_ENDPOINTS.GET_PRIVACY_SEQUENCE).then(resp => {
              const privacySeqNr = (resp.body as TermsUse).termSeqNr;
              this.context.set({ privacySeqNr });
              this.historyService.push(APPLICATION_ROUTES.ASSIGN_PRIVACY, { privacySeqNr });
            });
          }
          else {
            const token = AuthenticationService.getJWTToken() as JWTToken;
            const cdPhysicalPerson: string = token.claims[TokenConstants.CD_PHYSICAL_PERSON] as string;
            const params = { cdPhysicalPerson };
            this.historyService.push(APPLICATION_ROUTES.EXAMS_RESULTS, params);
          }
        });
      });
    }
  }
}
